import { Helmet } from "react-helmet-async";

const RAW_SITE = "https://www.bondpay.au";
const SITE = RAW_SITE.replace(/\/+$/, "");
const abs = (path: string) =>
  `${SITE}${path.startsWith("/") ? path : `/${path}`}`;

export default function DefaultSEO() {
  const orgLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": `${SITE}#org`,
    name: "BondPay",
    url: SITE,
    logo: {
      "@type": "ImageObject",
      url: abs("/logo.png"),
    },
    contactPoint: [
      {
        "@type": "ContactPoint",
        contactType: "customer support",
        email: "hello@bondpay.au",
        areaServed: "AU",
        availableLanguage: ["en"],
      },
    ],
  };

  const siteLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "BondPay",
    url: SITE,
    inLanguage: "en-AU",
    publisher: { "@id": `${SITE}#org` },
    potentialAction: {
      "@type": "SearchAction",
      target: `${SITE}/blog?query={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  };

  const ogImage = abs("/og-default.jpg");

  const ghost = (process.env.REACT_APP_GHOST_URL || "").replace(/\/+$/, "");
  const hasGhost = !!ghost;

  return (
    <Helmet defaultTitle="BondPay" titleTemplate="%s | BondPay">
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width,initial-scale=1" />
      <meta name="theme-color" content="#B62EA0" />
      <meta name="color-scheme" content="light" />
      <meta name="format-detection" content="telephone=no" />
      <meta name="referrer" content="strict-origin-when-cross-origin" />
      <meta name="robots" content="index,follow" />
      <meta
        name="googlebot"
        content="index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1"
      />

      <link rel="icon" href="/favicon.ico" />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href="/apple-touch-icon.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href="/favicon-32x32.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="/favicon-16x16.png"
      />
      <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#B62EA0" />
      <meta name="msapplication-TileColor" content="#B62EA0" />

      <link rel="canonical" href={`${SITE}/`} />

      <meta property="og:site_name" content="BondPay" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={`${SITE}/`} />
      <meta property="og:image" content={ogImage} />
      <meta
        property="og:image:alt"
        content="BondPay — interest-free bond split into four payments"
      />
      <meta property="og:locale" content="en_AU" />

      <meta name="twitter:card" content="summary_large_image" />

      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
      {hasGhost && (
        <>
          <link rel="preconnect" href={ghost} crossOrigin="" />
          <link rel="dns-prefetch" href={ghost} />
        </>
      )}

      <link
        rel="alternate"
        type="application/rss+xml"
        title="BondPay Blog RSS"
        href={abs("/feed.xml")}
      />

      <script type="application/ld+json">{JSON.stringify(orgLd)}</script>
      <script type="application/ld+json">{JSON.stringify(siteLd)}</script>
    </Helmet>
  );
}
